/** Must match the `getGet('mdeFeedback')` read in Posterbuilder.php. */
export const MDE_FEEDBACK_URL_PARAM = 'mdeFeedback';

/** The subset of backend `MdeErrorCode` that `makedesigneditable/start` can refuse with. */
export enum MdeStartErrorCode {
  NOT_ALLOWED = 'notAllowed',
  FEATURE_DISABLED = 'featureDisabled',
  IMAGE_NOT_FOUND = 'imageNotFound',
  IMAGE_NOT_ALLOWED = 'imageNotAllowed',
  ENQUEUE_FAILED = 'enqueueFailed',
}

/** `posterHashedId` is the blank poster pre-created for the job; null when the image has no known dimensions. */
export interface MdeStartResponse {
  jobId: string;
  posterHashedId: string | null;
}

export interface MdeStatusRequest {
  jobId: string;
}

/** The fields of the backend `MdeJobResult::toArray()` the client reads. */
export interface MdeJobResult {
  posterHashedId: string;
  jobHashedId: string;
}

export interface MdeOutcome {
  jobId: string;
  posterHashedId: string;
}
